import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

const money = (v) => Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });

export default function ClientesSinPrestamoTable({ rows = [], loading = false, error = '' }) {
  const formatDate = (date) => {
    if (!date) return '—';
    try {
      return format(parseISO(date), 'dd/MM/yyyy', { locale: es });
    } catch (error) {
      return '—';
    }
  };

  const getEstadoBadge = (estadoCliente) => {
    if (estadoCliente === 'sin_prestamo_activo') {
      return (
        <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800">
          CON HISTORIAL
        </span>
      );
    } else if (estadoCliente === 'sin_registro_prestamos') {
      return (
        <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-800">
          SIN REGISTRO
        </span>
      );
    }
    return (
      <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
        {estadoCliente}
      </span>
    );
  };

  return (
    <>
      {error && (
        <div className="mt-3 bg-red-50 text-red-700 p-4 rounded-lg border border-red-200">
          {error}
        </div>
      )}

      <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500 bg-gray-50 border-b border-gray-200">
                <th className="py-3 px-3 text-center">#</th>
                <th className="py-3 px-3 text-center">CLIENTE</th>
                <th className="py-3 px-3 text-center">DNI</th>
                <th className="py-3 px-3 text-center">ESTADO</th>
                <th className="py-3 px-3 text-center">ÚLTIMO PRÉSTAMO</th>
                <th className="py-3 px-3 text-center">TASA %</th>
                <th className="py-3 px-3 text-center">ÚLTIMA CUOTA</th>
                <th className="py-3 px-3 text-center">TELÉFONO</th>
                <th className="py-3 px-3 text-center">DIRECCIÓN</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td className="py-8 px-4 text-center text-gray-500" colSpan={9}>
                    {loading ? 'Cargando…' : 'Sin resultados'}
                  </td>
                </tr>
              )}

              {rows.map((cliente, index) => (
                <tr
                  key={cliente.id}
                  className="border-b border-gray-200 last:border-b-0 transition hover:bg-rose-50/40 odd:bg-white even:bg-gray-50/40"
                >
                  <td className="py-3 px-3 text-center font-medium text-gray-600">
                    {index + 1}
                  </td>

                  <td className="py-3 px-3">
                    <span className="font-medium text-gray-900">
                      {cliente.nombre_completo}
                    </span>
                  </td>

                  <td className="py-3 px-3 text-center text-gray-700">
                    {cliente.datos?.numero_documento || '—'}
                  </td>

                  <td className="py-3 px-3 text-center">
                    {getEstadoBadge(cliente.estado_cliente)}
                  </td>

                  <td className="py-3 px-3 text-center font-semibold text-gray-900">
                    {cliente.ultimo_prestamo ? money(cliente.ultimo_prestamo.monto_prestamo) : '—'}
                  </td>

                  <td className="py-3 px-3 text-center">
                    {cliente.ultimo_prestamo ? (
                      <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                        {Number(cliente.ultimo_prestamo.tasa_interes || 0).toFixed(2)}%
                      </span>
                    ) : (
                      <span className="text-gray-500">—</span>
                    )}
                  </td>

                  <td className="py-3 px-3 text-center text-gray-900">
                    {cliente.ultimo_prestamo?.ultima_cuota_pagada ? (
                      formatDate(cliente.ultimo_prestamo.ultima_cuota_pagada.fecha_pago)
                    ) : (
                      <span className="text-gray-500">—</span>
                    )}
                  </td>

                  <td className="py-3 px-3 text-center text-gray-700">
                    {cliente.contacto?.telefono || '—'}
                  </td>

                  <td className="py-3 px-3 text-gray-600 text-xs max-w-xs truncate" title={cliente.direccion_completa}>
                    {cliente.direccion_completa}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        {loading && rows.length > 0 && (
          <div className="p-4">
            <div className="mx-auto h-1 w-32 bg-gray-100 rounded overflow-hidden">
              <div className="h-full w-1/2 animate-pulse bg-red-600"></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
